import { AuditTrailListParam } from "../interfaces/audit-trail-interface";
import axiosInstance from "../utils/axios-instance";

export const listAuditTrail = async (data: AuditTrailListParam) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/audit-trail/list`,
    {
      data: {},
      params: {
        ...data,
      },
    }
  );
  return response.data;
};
